import React from 'react'

const ProfilePic = ({profilePhoto, name}) => {
  return (
    <>
    {profilePhoto ? (
        <img
          src={profilePhoto}
          alt=""
          className="rounded-full w-full h-full object-cover"
        />
      ) : (
        <div className="object-cover rounded-full w-full h-full font-pop bg-primarygreen flex items-center justify-center">
          <span className={`text-white `}>
            {name?.charAt(0)}
          </span>
        </div>
      )}
    </>
  )
}

export default ProfilePic